//import React from 'react';
//import authService from '../../api-authorization/AuthorizeService'
//import axios from 'axios'
//import Box from '@mui/material/Box';
//import Grid from '@mui/material/Grid';
//import Card from '@mui/material/Card';
//import CardActions from '@mui/material/CardActions';
//import CardContent from '@mui/material/CardContent';
//import CardMedia from '@mui/material/CardMedia';
//import Button from '@mui/material/Button';
//import Typography from '@mui/material/Typography';
//import createCache from '@emotion/cache';

//const muiCache = createCache({
//    key: 'mui-datatables',
//    prepend: true,
//});

//export default function PlayerEventsList({ player }) {
//    return (
//        <div className="mt-10 mb-10">
//            {
//                <Box sx={{ pt: 1, pb: 1 }}>
//                    <Grid container direction="row" rowSpacing={1} columnSpacing={1} align-items="flex-end">
//                        <Grid item xs={12} lg={6}>
//                            <Card sx={{}}>
//                                {/*<CardMedia*/}
//                                {/*    sx={{ height: 140 }}*/}
//                                {/*    image="/static/images/cards/contemplative-reptile.jpg"*/}
//                                {/*    title="green iguana"*/}
//                                {/*/>*/}
//                                <CardContent>
//                                    <Typography gutterBottom variant="h5" component="div" color="text.primary">
//                                        FIDE Profile :   {player.fidePlayerId > 0 ? player.fideName : "Player has no FIDE ID"}
//                                    </Typography>
//                                    <table>
//                                        <tbody>
//                                            <tr>
//                                                <td align="right" nowrap="nowrap">Membership</td>
//                                                <td align="right" nowrap="nowrap">   :   </td>
//                                                <td align="left" nowrap="nowrap">{player.fidePlayerId > 0 ? (<a href={'https://ratings.fide.com/profile/' + player.fidePlayerId} target='_blank' rel='noreferrer'>{player.fidePlayerId +" [" + player.fideSex + "," + player.fideBirthday+"]"}</a>) : "N/A"}</td>
//                                            </tr>
//                                            <tr>
//                                                <td align="right" nowrap="nowrap">Country</td>
//                                                <td align="right" nowrap="nowrap">   :   </td>
//                                                <td align="left" nowrap="nowrap">{player.fidePlayerId > 0 ?player.fideCountry : "N/A"}</td>
//                                            </tr>
//                                            <tr>
//                                                <td align="right" nowrap="nowrap">OTB Rating</td>
//                                                <td align="right" nowrap="nowrap">   :   </td>
//                                                <td align="left" nowrap="nowrap">{player.fidePlayerId > 0 ? "Regular " + player.fideRating + " [K" + player.fidekValue + "] | Blitz " + player.fideBlitzRating + " [K" + player.fideBlitzKValue + "] | Rapid " + player.fideRapidRating + " [K" + player.fideRapidKValue + "] ": "N/A"}</td>
//                                            </tr>
//                                            <tr>
//                                                <td align="right" nowrap="nowrap">Title</td>
//                                                <td align="right" nowrap="nowrap">   :   </td>
//                                                <td align="left" nowrap="nowrap">{player.fidePlayerId > 0 ? player.fideTitle : "N/A"} {player.fidePlayerId > 0 ? player.fideWomenTitle : ""} {player.fidePlayerId > 0 ? player.fideOtherTitle : ""}</td>
//                                            </tr>
//                                        </tbody>
//                                    </table>
//                                </CardContent>
//                            </Card>
//                        </Grid>
//                        <Grid item xs={12} lg={6}>
//                            <Card sx={{}}>
//                                <CardContent>
//                                    <Typography gutterBottom variant="h5" component="div" color="text.primary">
//                                        USCF Profile :   {player.uscfPlayerId > 0 ? player.uscfName : "Player has no USCF ID"}
//                                    </Typography>
//                                    <table>
//                                        <tbody>
//                                            <tr>
//                                                <td align="right" nowrap="nowrap">Membership</td>
//                                                <td align="right" nowrap="nowrap">   :   </td>
//                                                <td align="left" nowrap="nowrap">{player.uscfPlayerId > 0 ? (<a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + player.uscfPlayerId} target='_blank' rel='noreferrer'>{player.uscfPlayerId + " [Exp " +player.uscfExpDate.split("T")[0]+"]"}</a>) : "N/A"}</td>
//                                            </tr>
//                                            <tr>
//                                                <td align="right" nowrap="nowrap">State</td>
//                                                <td align="right" nowrap="nowrap">   :   </td>
//                                                <td align="left" nowrap="nowrap">{player.uscfPlayerId > 0 ? player.uscfState: "N/A"}</td>
//                                            </tr>
//                                            <tr>
//                                                <td align="right" nowrap="nowrap">OTB Rating</td>
//                                                <td align="right" nowrap="nowrap">   :   </td>
//                                                <td align="left" nowrap="nowrap">{player.uscfPlayerId > 0 ? "Regular "+player.uscfRating+" | Blitz "+player.uscfBlitzRating+" | Quick "+player.uscfQuickRating : "N/A"}</td>
//                                            </tr>
//                                            <tr>
//                                                <td align="right" nowrap="nowrap">Online Rating</td>
//                                                <td align="right" nowrap="nowrap">   :   </td>
//                                                <td align="left" nowrap="nowrap">{player.uscfPlayerId > 0 ? "Regular " + player.uscfOnlineRating + " | Blitz " + player.uscfOnlineBlitzRating + " | Quick " + player.uscfOnlineQuickRating : "N/A"}</td>
//                                            </tr>
//                                        </tbody>
//                                    </table>
//                                </CardContent>
//                                {/*<CardActions>*/}
//                                {/*    <Button size="small">Share</Button>*/}
//                                {/*    <Button size="small">Learn More</Button>*/}
//                                {/*</CardActions>*/}
//                            </Card>
//                        </Grid>
//                    </Grid>
//                </Box>
//                }

//        </div>
//    )
//}

import React, { useState } from 'react';
import axios from 'axios';
import { parse } from 'node-html-parser';

const PlayerEventList = ({ playerFideID }) => {
    const [tournaments, setTournaments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchTournaments = async () => {
        setLoading(true);
        setError(null);
        let allTournaments = [];

        try {
            const startDate = new Date(2000, 0, 1); // January 1, 2000
            const endDate = new Date(); // Current date
            const proxyUrl = 'https://cors-anywhere.herokuapp.com/'; //'https://proxy.cors.sh/';
            const proxyAPIKey = 'temp_284c78430edfcbc864a9c391f9ea02e6';

            for (let date = endDate; date >= startDate; date.setMonth(date.getMonth() - 1)) {
                try {
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
                    const day = '01';
                    const period = `${year}-${month}-${day}`;

                    const targetUrl = 'https://corsproxy.io/?' + encodeURIComponent(`https://ratings.fide.com/calculations.phtml?id_number=${playerFideID}&period=${period}&rating=0`);

                    //https://ratings.fide.com/calculations.phtml?id_number=1503014&period=2024-07-01&rating=0
                    const response = await axios.get(proxyUrl + targetUrl, {
                        headers: {
                            'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.124 Safari/537.36',
                            'x-cors-api-key': 'temp_284c78430edfcbc864a9c391f9ea02e6'
                        }
                    });

                    const root = parse(response.data);
                    const tournamentNameElement = root.querySelector('.contentpanel'); // Update selector as per actual HTML structure
                    if (tournamentNameElement) {
                        const tournamentName = tournamentNameElement.innerText.trim();
                        allTournaments.push({ name: tournamentName, period });
                    }
                }
                catch (error) {
                    setError('Failed to fetch tournaments for ');
                }
                
            }

            setTournaments(allTournaments);
        } catch (error) {
            setError('Failed to fetch tournaments');
        } finally {
            setLoading(false);
        }




        //try {
        //    // Using a proxy to bypass CORS policy issues
        //    const proxyUrl = 'https://cors-anywhere.herokuapp.com/';
        //    const targetUrl = `https://ratings.fide.com/profile/${playerFideID}/calculations`;

        //    //var url = 'https://corsproxy.io/?' + targetUrl;
        //    var url = 'https://proxy.cors.sh/' + targetUrl;
            
        //    //url = targetUrl;




























        //    const response = await axios.get(url, {
        //        headers: {
        //            'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.124 Safari/537.36',
        //            'x-cors-api-key': 'temp_284c78430edfcbc864a9c391f9ea02e6'
        //        }
        //    });
        //    const root = parse(response.data);
        //    const links = root.querySelectorAll('a').map(a => a.getAttribute('href'));
        //    const tournamentLinks = links.filter(link => link.includes('calculations.phtml'));

        //    const tournamentDetails = await Promise.all(tournamentLinks.map(async (link) => {
        //        const detailResponse = await axios.get(proxyUrl + `https://ratings.fide.com${link}`);
        //        const detailRoot = parse(detailResponse.data);
        //        const tournamentName = detailRoot.querySelector('.contentpanel').innerText.trim();
        //        return { name: tournamentName, link: `https://ratings.fide.com${link}` };
        //    }));

        //    setTournaments(tournamentDetails);
        //} catch (error) {
        //    setError('Failed to fetch tournaments');
        //} finally {
        //    setLoading(false);
        //}
    };

    return (
        <div>
            <button onClick={fetchTournaments}>Fetch Tournaments</button>
            {loading && <p>Loading...</p>}
            {error && <p>{error}</p>}
            <ul>
                {tournaments.map((tournament, index) => (
                    <li key={index}>
                        <a href={tournament.link} target="_blank" rel="noopener noreferrer">
                            {tournament.name}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default PlayerEventList;
